/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SurveyDataCutName } from '../models/SurveyDataCutName';
import type { SurveyDataCutRenameResponseItem } from '../models/SurveyDataCutRenameResponseItem';
import type { SurveyDataCutSort } from '../models/SurveyDataCutSort';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class SurveyDataCutNameService {

    /**
     * Get Survey Data Cuts With Names
     * @returns SurveyDataCutRenameResponseItem Success
     * @throws ApiError
     */
    public static getSurveyDataCutNames({
        surveyId,
        offset,
        limit,
        search,
        mapped,
        relabeled,
        paymarketIds,
        sort,
    }: {
        surveyId: string,
        /**
         * Page number
         */
        offset?: number,
        /**
         * Max items per page
         */
        limit?: number,
        search?: string,
        mapped?: boolean,
        relabeled?: boolean,
        paymarketIds?: Array<number>,
        sort?: SurveyDataCutSort,
    }): CancelablePromise<Array<SurveyDataCutRenameResponseItem>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/surveyDataCutName',
            query: {
                'surveyId': surveyId,
                'offset': offset,
                'limit': limit,
                'search': search,
                'mapped': mapped,
                'relabeled': relabeled,
                'paymarketIds': paymarketIds,
                'sort': sort,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Relabel Survey Data Cut
     * @returns SurveyDataCutName Success
     * @throws ApiError
     */
    public static relabelSurveyDataCut({
        requestBody,
    }: {
        requestBody: {
            name: string;
            surveyId: string;
            surveyDataCutId: string;
        },
    }): CancelablePromise<SurveyDataCutName> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/surveyDataCutName',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Delete Survey Data Cut Name
     * @returns any Success
     * @throws ApiError
     */
    public static deleteSurveyDataCutName({
        surveyDataCutNameId,
    }: {
        /**
         * Survey Data Cut Name Id
         */
        surveyDataCutNameId: string,
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/surveyDataCutName/{surveyDataCutNameId}',
            path: {
                'surveyDataCutNameId': surveyDataCutNameId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

}
